import { CountryCode } from '~shared/constants/country-code.enum';
import { HEADER_LOGO_LINK, HEADER_LOGO_NAME } from '../constants';
import { AccountType } from '~shared/models';
import { APP_ALL_OFFERS_ROUTE, APP_EMPLOYEE_CUSTOMERS_LIST, APP_LANDING_PAGE_ROUTE } from '~shared/constants';
import { environment } from '~env/environment';

export namespace HeaderLogoUtil {
  export function getHeaderLogoName(market: string) {
    if (!market || !HEADER_LOGO_NAME[market]) {
      return HEADER_LOGO_NAME[CountryCode.Germany];
    } else {
      return HEADER_LOGO_NAME[market];
    }
  }

  export function getHeaderLogoLink(market: string, accountType: AccountType = AccountType.CUSTOMER) {
    const noMarket = !market || !HEADER_LOGO_LINK[market];
    const marketCode = noMarket ? CountryCode.Germany : market;
    let mainLink = HEADER_LOGO_LINK[marketCode];

    if (accountType === AccountType.EMPLOYEE) {
      mainLink = `${environment.appBaseUrl()}/${APP_EMPLOYEE_CUSTOMERS_LIST}`;
    }

    if (accountType === AccountType.EMPLOYEE_AS_CUSTOMER) {
      mainLink = `${environment.appBaseUrl()}/${APP_LANDING_PAGE_ROUTE}/${APP_ALL_OFFERS_ROUTE}`;
    }

    return mainLink;
  }
}
